import React from "react";
import { ArrowRight } from "lucide-react";

const SkuOverview = ({ questionnaireData }) => {
  const selectedSkus = questionnaireData.skuSelection;

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">
        Module Configuration Overview
      </h3>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <p className="text-lg text-blue-800 font-medium mb-4">
          You've selected {selectedSkus.length} module
          {selectedSkus.length > 1 ? "s" : ""} for configuration:
        </p>
        <ul className="list-disc list-inside mb-6 text-blue-700">
          {selectedSkus.map((sku) => (
            <li key={sku}>Workday {sku}</li>
          ))}
        </ul>
        <div className="bg-white p-4 rounded-md border border-blue-200">
          <p className="text-gray-700">
            {selectedSkus.length === 1 ? (
              <>
                Let's proceed with configuring{" "}
                <strong>Workday {selectedSkus[0]}</strong>.
              </>
            ) : (
              <>
                Let's proceed with configuring{" "}
                <strong>Workday {selectedSkus[0]}</strong> first. Once we
                complete the {selectedSkus[0]} configuration, we'll return to
                configure
                {selectedSkus.slice(1).map((sku, index, arr) => (
                  <span key={sku}>
                    {arr.length === 1
                      ? " "
                      : index === arr.length - 1
                      ? " and "
                      : ", "}
                    <strong>Workday {sku}</strong>
                  </span>
                ))}
                .
              </>
            )}
          </p>
          <div className="mt-4 flex items-center text-blue-600">
            <ArrowRight className="mr-2" size={16} />
            <span className="font-medium">
              Next: {selectedSkus[0]} Configuration Setup
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkuOverview;
